var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29.99 39.98" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a", transform: "translate(-984 -154.02)" },
        React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M989 159.02h19.99V189H989z" })
      ),
      React.createElement(
        "clipPath",
        { id: "b", transform: "translate(-984 -154.02)" },
        React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M0 0h1281v1258H0z" })
      ),
      React.createElement(
        "clipPath",
        { id: "c", transform: "translate(-984 -154.02)" },
        React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M989 159h20v31h-20z" })
      ),
      React.createElement(
        "clipPath",
        { id: "d", transform: "translate(-984 -154.02)" },
        React.createElement("path", { d: "M1005.81 159a3.24 3.24 0 0 0-3.18 3.28v6.42a3 3 0 0 0-1.36-.32 3.1 3.1 0 0 1-4.54 0 3 3 0 0 0-1.36.32v-6.4a3.18 3.18 0 1 0-6.36 0v16.42a10 10 0 1 0 20 .1.65.65 0 0 0 0-.1V162.3a3.24 3.24 0 0 0-3.2-3.3zm-1.36 3.28a1.36 1.36 0 1 1 2.73 0v12.1a5.84 5.84 0 0 0-2.73-1.22zm-4.54 9.38a1.36 1.36 0 1 1 2.73 0v1.41h-2.74zm-4.54 0a1.36 1.36 0 1 1 2.73 0v1.41h-2.73zm3.63 15.5a8.32 8.32 0 0 1-8.17-8.44V162.3a1.36 1.36 0 1 1 2.73 0V174a6.53 6.53 0 0 0 .65 2.78 5 5 0 0 0 4.79 2.85h.33a5.59 5.59 0 0 0-1.24 3.75.91.91 0 1 0 1.82 0 3.54 3.54 0 0 1 3.63-3.75.94.94 0 0 0 0-1.88H999a3.42 3.42 0 0 1-2.55-.94 3.84 3.84 0 0 1-1-1.88h8.06a4.22 4.22 0 0 1 .91.12 3.29 3.29 0 0 1 2.64 2.69 5 5 0 0 1 .08.94 9.11 9.11 0 0 1 0 .94 8.3 8.3 0 0 1-8.13 7.51z", clipRule: "evenodd", fill: "none" })
      ),
      React.createElement(
        "clipPath",
        { id: "e", transform: "translate(-984 -154.02)" },
        React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M989 159h20v30h-20z" })
      )
    ),
    React.createElement(
      "g",
      { "data-name": "Layer 2" },
      React.createElement(
        "g",
        { "data-name": "Layer 1" },
        React.createElement("path", { d: "M8.4 6.07l-2 .83-.25 19.88s1.71 3.33 1.88 3.54 3.83 2.79 3.83 2.79l4.75.46 5.42-3.21 1.5-3.83.58-6V7.77l-2.12-2-2.33 1.42-.13 9.38-2.21-1.17-2.37 1-1.8-1.42-2.71.67V6.86z", fill: "#fff" }),
        React.createElement(
          "g",
          { clipPath: "url(#a)" },
          React.createElement(
            "g",
            { clipPath: "url(#b)" },
            React.createElement(
              "g",
              { clipPath: "url(#c)" },
              React.createElement(
                "g",
                { clipPath: "url(#d)" },
                React.createElement(
                  "g",
                  { clipPath: "url(#e)" },
                  React.createElement("path", { fill: "#020202", d: "M0 0h29.99v39.98H0z" })
                )
              )
            )
          )
        )
      )
    )
  );
});